/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_Status_ConflictInputs */

const cs_ebr_broker_status_conflict = /** @type {(inputs: Ebr_Broker_Status_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konflikt`)
};

const en_ebr_broker_status_conflict = /** @type {(inputs: Ebr_Broker_Status_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflict`)
};

/**
* | output |
* | --- |
* | "Conflict" |
*
* @param {Ebr_Broker_Status_ConflictInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_status_conflict = /** @type {((inputs?: Ebr_Broker_Status_ConflictInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_Status_ConflictInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_status_conflict(inputs)
	return cs_ebr_broker_status_conflict(inputs)
});